import { AxiosResponse } from "axios";
import { actualizarEstadoCompania, companiaSeguroRequest } from "../models/companiaSeguro";
import axiosInstance from "../../../../interceptors/axiosInstance";


const actualizarCompaniaService = async (dataRequest: companiaSeguroRequest) => {
    const response: AxiosResponse = await axiosInstance.put(`siscred-api-maestros/v1/companias-seguro/actualizar/${dataRequest.id}`, dataRequest);
    return response;
};

const crearCompaniaService = async (dataRequest: companiaSeguroRequest) => {
    const response: AxiosResponse = await axiosInstance.post(`siscred-api-maestros/v1/companias-seguro/crear`, dataRequest);
    return response;
};

const actualizarEstadoCompaniaService = async (dataRequest: actualizarEstadoCompania) => {
    const response: AxiosResponse = await axiosInstance.patch(`siscred-api-maestros/v1/companias-seguro/actualizar-estado-compania/${dataRequest.id}`, dataRequest);
    return response;
};

export {
    actualizarCompaniaService,
    crearCompaniaService,
    actualizarEstadoCompaniaService
}
